<c-card class="mb-3">
  <c-card-body class="p-3">
    <h5 class="mb-3">Attrition Updates</h5>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div class="d-flex align-items-center gap-3">
        <div>
          <label for="yearInput" class="form-label me-2 mb-0">Year:</label>
          <input id="yearInput" type="number" class="form-control d-inline-block" style="width: 100px;" min="2025" [max]="currentYear" [value]="selectedYear" (change)="onYearChange($event)">
        </div>
        <div>
          <input
            type="text"
            class="form-control"
            style="width: 240px;"
            placeholder="Search by name, client, role..."
            [(ngModel)]="searchQuery"
            (ngModelChange)="onSearchChange()"
          >
        </div>
      </div>
      <div class="d-flex align-items-center gap-2">
        <div class="me-3">
          <span class="fw-bold">Total:</span>
          <span>{{ totalItems }}</span>
        </div>
        <select class="form-select form-select-sm w-auto" [(ngModel)]="itemsPerPage" name="itemsPerPage" (change)="onItemsPerPageChange()">
          <option *ngFor="let size of [10, 20, 50, 100]" [value]="size">{{ size }} / page</option>
        </select>
        <div class="d-flex align-items-center gap-1">
          <button class="btn btn-outline-primary btn-sm" [disabled]="activePage === 1" (click)="onPageChange(activePage - 1)">&larr;</button>
          <ng-container *ngFor="let page of getChunkedPagination(); let idx = index">
            <ng-container *ngIf="page === 'ellipsis'">
              <button type="button" class="btn btn-sm btn-outline-secondary" (click)="onChunkEllipsisClick(idx > 0)">...</button>
            </ng-container>
            <ng-container *ngIf="page !== 'ellipsis'">
              <button type="button" class="btn btn-sm" [ngClass]="{'btn-primary': activePage === page, 'btn-outline-primary': activePage !== page}" (click)="onPageChange(page)">{{ page }}</button>
            </ng-container>
          </ng-container>
          <button class="btn btn-outline-primary btn-sm" [disabled]="activePage === totalPages" (click)="onPageChange(activePage + 1)">&rarr;</button>
        </div>
      </div>
    </div>
  <div class="table-responsive" style="overflow-x: auto;">
  <table class="table table-bordered table-hover align-middle" style="table-layout: fixed; width: max-content; min-width: 100%;">
        <thead class="table-light">
          <tr>
              <th style="width: 80px;">Status</th>
              <th style="width: 180px;">Client</th>
              <th style="width: 150px;">Employee Name</th>
              <th style="width: 80px;">Role</th>
              <th style="width: 110px;">Start Date</th>
              <th style="width: 110px;">Exit Date</th>
              <th style="width: 80px;">Days</th>
              <th style="width: 100px;">Voluntary/Involuntary</th>
              <th style="width: 120px;">Replacement Needed:</th>
              <th style="width: 80px;">Actions</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let attrition of attritions; let i = index">
            <tr>
              <td>{{ attrition.status }}</td>
              <td>{{ attrition.client }}</td>
              <td>{{ attrition.employee_name }}</td>
              <td>{{ attrition.role }}</td>
              <td>{{ attrition.start_date | date:'yyyy-MM-dd' }}</td>
              <td>{{ attrition.exit_date | date:'yyyy-MM-dd' }}</td>
              <td>{{ attrition.days }}</td>
              <td>{{ attrition.voluntary_involuntary }}</td>
              <td>{{ attrition.replacement_needed }}</td>
              <td class="d-flex justify-content-center align-items-center">
                <button class="btn btn-sm btn-primary me-2" (click)="toggleRow(i)">
                  {{ expandedIndex === i ? '-' : '+' }}
                </button>
                <a class="btn btn-sm btn-outline-secondary" title="Edit"
                   [routerLink]="['/reports/attrition-updates/form', attrition.id]">
                  <c-icon name="cil-pencil" size="sm"></c-icon>
                </a>
              </td>
            </tr>
            <tr *ngIf="expandedIndex === i">
              <td colspan="13" class="bg-light p-2">
                <div class="row">
                  <div class="col-md-6 p-3">
                    <strong>Work Hours:</strong> {{ attrition.hours }} <br><br>
                    <strong>Reason for Exit:</strong> {{ attrition.reason_for_exit }}
                  </div>
                  <div class="col-6 p-3">
                    <strong>Updates &amp; Action Items:</strong>
                    <ng-container *ngIf="expandedIndex === i">
                      <ng-container *ngIf="editingActionItemsIndex === i; else viewActionItems">
                      <ul class="mb-0 ps-3 list-unstyled">
                        <li *ngFor="let item of actionItemsDraft; let idx = index" class="d-flex align-items-center mb-2">
                          <input type="text" class="form-control form-control-sm me-2" [(ngModel)]="actionItemsDraft[idx].action_item" placeholder="Action item..." />
                          <button type="button" class="btn btn-sm btn-danger" (click)="removeActionItem(idx)"><c-icon name="cil-x" size="sm"></c-icon></button>
                        </li>
                      </ul>
                      <button type="button" class="btn btn-sm btn-success ms-2 me-2" (click)="addActionItem()">
                        <c-icon name="cil-plus" size="sm"></c-icon> <span style="color: #fff;">Add</span>
                      </button>
                      <button type="button" class="btn btn-sm btn-primary me-2" (click)="saveActionItems(i)">Save</button>
                      <button type="button" class="btn btn-sm btn-secondary" (click)="cancelEditActionItems()">Cancel</button>
                    </ng-container>
                    <ng-template #viewActionItems>
                      <ng-container *ngIf="attrition.action_items?.length; else noActions">
                        <ul class="mb-0 ps-3 list-unstyled">
                          <li *ngFor="let item of attrition.action_items">
                            <c-icon name="cil-check" class="text-success me-2" size="sm"></c-icon>
                            {{ item.action_item }}
                          </li>
                        </ul>
                      </ng-container>
                      <ng-template #noActions>-</ng-template>
                      <button type="button" class="btn btn-sm btn-outline-primary mt-2" (click)="startEditActionItems(i)">
                        <c-icon name="cil-pencil" size="sm"></c-icon> Edit
                      </button>
                    </ng-template>
                  </ng-container>
                  </div>
                </div>
              </td>
            </tr>
          </ng-container>
          <tr *ngIf="!attritions.length">
            <td colspan="13" class="text-center">No data found.</td>
          </tr>
        </tbody>
      </table>
    </div>
  <!-- Pagination below table removed, only above remains -->
  </c-card-body>
</c-card>
